//https://api.iconify.design/fa/play.svg
import { Controller } from '@hotwired/stimulus'
import { getFlow } from '../helpers/controllerHelpers/utils'
import { env } from '../helpers/env'
import { log } from '../helpers/debug'

export default class extends Controller {
  static classes = ['opened', 'closed']
  static targets = ['overlay', 'contentContainer', 'closeButton', 'box']
  static values = {
    open: Boolean,
    selector: String,
    prevent: Boolean,
    resetPage: Boolean,
  }

  declare readonly openedClass: string
  declare openValue: boolean
  declare readonly selectorValue: string
  declare readonly preventValue: string
  declare readonly resetPageValue: string
  declare readonly overlayTarget: HTMLElement
  declare readonly hasOverlayTarget: boolean
  declare readonly contentContainerTarget: HTMLElement
  declare readonly hasContentContainerTarget: boolean
  hasTriggered: boolean

  async connect() {
    window.addEventListener('click', this.listenForPopupTrigger)
  }
  disconnect() {
    window.removeEventListener('click', this.listenForPopupTrigger)
  }

  listenForPopupTrigger = (event:  Event) => {
    log('Popup: Click detected on page', event)
    const validElements = document.querySelectorAll(
      env() === 'local' || env().startsWith('preview-')
        ? '[click-trigger="flow-popup"]'
        : decodeURIComponent(this.selectorValue)
    )
    log('validElements', validElements)

    // const validElements = document.querySelectorAll('div')
    const flow = getFlow(this)
    validElements.forEach((el) => {
      if (!el.contains(event.target as HTMLElement)) return
      if (this.preventValue) {
        if (typeof event.preventDefault === 'function') event.preventDefault()
        if (typeof event.stopPropagation === 'function') event.stopPropagation()
      }
      if (this.resetPageValue) this.dispatch('reset-page')

      this.openPopup()

      const onViewActions = !this.hasTriggered ? flow.outputs_onviewflow || [] : []
      const onEnterActions = flow.outputs_onopenpopup || []
      const actions = Array.from(new Set([...onViewActions, ...onEnterActions]))
      this.hasTriggered = true

      if (actions.length > 0) this.dispatch('action', { detail: { actions } })
      const collected = {}
      const targetAttributes = event.target && (event.target as HTMLElement).attributes
      if (targetAttributes) {
        for (let i = 0; i < targetAttributes.length; i++) {
          this.checkNode(targetAttributes[i], collected)
        }
      }
      const hostAttributes = el.attributes
      if (hostAttributes) {
        for (let i = 0; i < hostAttributes.length; i++) {
          this.checkNode(hostAttributes[i], collected)
        }
      }

      if (Object.keys(collected).length > 0)
        this.dispatch('prefill-update', { detail: { updates: collected, prefill: true } })
    })
  }

  openPopup(event?: Event) {
    if (event && typeof event.preventDefault == 'function') event.preventDefault()
    if (this.hasOverlayTarget) this.overlayTarget.classList.add(`in-${this.openedClass}`)
    if (this.hasContentContainerTarget)
      this.contentContainerTarget.classList.add(`in-${this.openedClass}`)
    this.element.classList.add(this.openedClass)
    this.openValue = true
  }
  closePopup(event?: Event) {
    if (event && typeof event.preventDefault == 'function') event.preventDefault()
    if (this.hasOverlayTarget) this.overlayTarget.classList.remove(`in-${this.openedClass}`)
    if (this.hasContentContainerTarget)
      this.contentContainerTarget.classList.remove(`in-${this.openedClass}`)
    this.element.classList.remove(this.openedClass)
    this.openValue = true
  }

  checkNode(node: Attr, collected: Record<string, unknown> = {}) {
    const start = 'savvy_flow_'
    const { nodeName, nodeValue } = node
    if (nodeName.startsWith(start)) {
      const propName = nodeName.slice(start.length)
      if (propName && nodeValue !== undefined) {
        const key = nodeName.slice(start.length)
        let value = nodeValue
        try {
          value = typeof nodeValue === 'string' ? JSON.parse(nodeValue) : nodeValue
        } catch (error) {
          value = nodeValue
        }

        collected[key] = value
      }
    }
  }
}
